import Common from '../common/Common';
import tmpl from './notiTemplate';
import modal from '../components/Modal';
import '../notice/AppLink';

class NotiFriends {
    nowNode = null; // li element
    puid = null;
    prid = null;
    isLoading = false;

    constructor() {
        this.api = this.setApi();
    }

    init() { 
        const com = Common.instance;    
        this.notiL10NData = com.l10nData.Notifications;

        this.addEvent();
    }

    setApi() {
        const isRc = /(rc-)/i.test(location.href) ? 'rc-' : '';
        const nowDomain = /(asia\.nc\.com)/i.test(location.href) ? 'asia.nc.com' : 'noti.plaync.com';
        const deleteNoti = `https://${isRc}${nowDomain}/noti/api/common/delete.jsonp`; //알림삭제
        const accept = `https://${isRc}sandbox.plaync.com/$!/my/friend/propose/accept.jsonp`; //친구수락
        const friendAgree = `https://${isRc}sandbox.plaync.com/$!/my/profile/updateAgreeFriendAccept.jsonp`; //약관동의
        const hideNoti = (puid, prid) => { //친구신청숨기기
            const prefix = `https://${isRc}sandbox.plaync.com`;
            return `${prefix}/$!/bns/friend/${puid}/${prid}/propose/hide.jsonp`;
        };

        return {
            deleteNoti,
            accept,
            friendAgree,
            hideNoti
        };
    }

    setNowNode(target) {
        this.nowNode = jQuery(target?.closest('li'));
        const { publisher = {}, proposalId, id } = this.nowNode.data();
        this.puid = publisher?.id;
        this.prid = proposalId;
        this.nickname = publisher?.nickname;
        this.id = id;
    }

    addEvent() {
        const ncCnb = jQuery('#nc-cnb');

        //수락 버튼 클릭
        ncCnb.on('click', '#notiList .wrapButton .btAllow', e => {
            const target = e.currentTarget;
            this.setNowNode(target);
            this.friendAccept();
        });

        //숨기기 버튼 클릭
        ncCnb.on('click', '#notiList .wrapButton .btHidden', e => {
            const target = e.currentTarget;
            this.setNowNode(target);
            this.friendHide();
        });

        //메신저 설치하기
        jQuery('body').on('click', '#friendAgree_M .btnNcMsn', e => {
            const isApp = window.npConf && window.npConf.isApp == 'true';

            if (isApp) {
                location.href = 'ncm://message?guid=' + this.puid;
            } else {
                AppLink.excute('ncm://message?guid=' + this.puid, this.nickname);
            }
        });
    }

    // 친구 수락
    friendAccept() {
        if (this.isLoading) {
            return;
        }

        jQuery.ajax({
            url: this.api.accept,
            data: {
                friendId: this.puid,
                proposalId: this.prid
            },
            dataType: 'jsonp',
            type: 'GET',
            jsonpCallback: 'callback',
            success: (data) => {
                const { result } = data || {};
                this.friendAcceptComp(result);
            },
            beforeSend: () => {
                this.isLoading = true;
            },
            complete: () => {
                this.isLoading = false;
            },
            error() {},
        });
    }

    // 친구요청 숨기기
    friendHide() {
        const { hideNoti, deleteNoti } = this.api || {};
        const hideNotiApi = hideNoti(this.puid, this.prid);

        jQuery.ajax({
            url: hideNotiApi,
            dataType: 'jsonp',
            type: 'GET',
            jsonpCallback: 'callback',
            data: '',
            success: () => {
                this.nowNode.hide();
            },
            error: () => {
                modal.openAlert({ title: this.notiL10NData.ErrorOccurred }); //알림 삭제 실패
            },
            beforeSend: () => {},
            complete: () => {}
        });

        jQuery.ajax({
            url: deleteNoti,
            dataType: 'jsonp',
            type: 'GET',
            jsonpCallback: 'callback',
            data: {
                notiID: this.id,
                targetCategory: 'GNB_NOTI'
            },
            success: () => {
                this.nowNode.hide();
            },
            error: () => {
                modal.openAlert({ title: notiL10NData.ErrorOccurred }); //알림 삭제 실패
            },
            beforeSend: () => {},
            complete: () => {}
        });
    }

    //서버응답
    async friendAcceptComp(result) {
        const notiL10NData = this.notiL10NData;

        switch(result) {
            case 'SUCCESS':
            case '4006':
                this.updateNowNodeAfterAccept();
                await modal.openAlert({ title: notiL10NData.FriendRequest });
                break;
            case 'NO_AGREEMENT_FRIEND_ACCEPT':
                this.friendAgreePop();
                break;
            case '4015':
            case '4016':
                await modal.openAlert({ title: notiL10NData.UnableAddFriends });
                break;
            case '4000':
                await modal.openAlert({ title: notiL10NData.InformationNotAvailable });
                break;
            default:
                await modal.openAlert({ title: notiL10NData.ErrorOccurred }); //친구 수락 실패
        }
    }

    //NC 친구 사용 동의 팝업
    async friendAgreePop(testNick) {
        const nick = testNick || this.nickname;
        const modalTmpl = tmpl.friendAgree_M(nick);

        const isConfirmed = await modal.openConfirm({ 
            title: modalTmpl,
            confirmButtonText: '예',
            cancelButtonText: '아니오'
        });

        if(isConfirmed) {
            jQuery.ajax({
                url: this.api.friendAgree,
                success: (data) => {
                    const { result } = data || {};
                    this.friendAgreeComp(result);
                },
                dataType: 'jsonp',
                type: 'GET',
                jsonpCallback: 'callback'
            });
        }
    }

    //팝업 동의 서버 응답
    friendAgreeComp(result) {
        if (result === 'SUCCESS') {
            setTimeout(() => {
                this.friendAccept();
            }, 150);
        } else {
            modal.openAlert({ title: this.notiL10NData.ErrorOccurred }); //'친구 동의 실패'
        }
    }

    // 친구 수락 후 Li 교체
    updateNowNodeAfterAccept() {
        const nowNode = this.nowNode;

        nowNode.empty();

        const okmsg = tmpl.tmpOkFriend(nowNode.data());
        nowNode.append(okmsg);
    }
}

export default new NotiFriends();

